import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class ItalianDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1; // Lunedì
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    switch (style) {
      case 'long':
        return [
          'domenica',
          'lunedì',
          'martedì',
          'mercoledì',
          'giovedì',
          'venerdì',
          'sabato',
        ];
      case 'short':
        return ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
      case 'narrow':
        return ['D', 'L', 'M', 'M', 'G', 'V', 'S'];
    }
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    switch (style) {
      case 'long':
        return [
          'gennaio',
          'febbraio',
          'marzo',
          'aprile',
          'maggio',
          'giugno',
          'luglio',
          'agosto',
          'settembre',
          'ottobre',
          'novembre',
          'dicembre',
        ];
      case 'short':
        return [
          'gen',
          'feb',
          'mar',
          'apr',
          'mag',
          'giu',
          'lug',
          'ago',
          'set',
          'ott',
          'nov',
          'dic',
        ];
      case 'narrow':
        return ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'];
    }
  }

  override format(date: Date, displayFormat: string): string {
    if (displayFormat === 'MMMM YYYY' || displayFormat === 'monthYearLabel') {
      const month = this.getMonthNames('long')[date.getMonth()];
      return `${month} ${date.getFullYear()}`;
    }
    // fallback al formato standard DD/MM/YYYY
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  override parse(value: any): Date | null {
    if (
      typeof value === 'string' &&
      value.length === 10 &&
      /^\d{2}\/\d{2}\/\d{4}$/.test(value)
    ) {
      const [day, month, year] = value.split('/');
      const d = parseInt(day, 10);
      const m = parseInt(month, 10);
      const y = parseInt(year, 10);
      // Validazione robusta
      if (y >= 1900 && y <= 2100 && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        const dateObj = new Date(y, m - 1, d);
        // Verifica che la data sia realmente valida (es. non 31/02/2025)
        if (
          dateObj.getFullYear() === y &&
          dateObj.getMonth() === m - 1 &&
          dateObj.getDate() === d
        ) {
          return dateObj;
        }
      }
      return null;
    }
    // fallback: usa il parse standard
    return super.parse(value);
  }
}
